import React from 'react'
import { BodySmallFontType } from './Typo'
import ComponentSpacing from '../containers/ComponentSpacing'

function FieldError(props) {
  return <BodySmallFontType className="et-field-error" {...props} />
}

export default FieldError
